import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");
export const API = `${BACKEND_URL}/api`;
const API_TIMEOUT_MS = Number(process.env.REACT_APP_API_TIMEOUT_MS || 15000);
export const AUTH_API_TIMEOUT_MS = Number(process.env.REACT_APP_AUTH_API_TIMEOUT_MS || 45000);

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: API_TIMEOUT_MS,
});

const INTERNAL_ERROR_PATTERN = /(cloudinary|vercel|contentstats|deployment could not|api\.cloudinary|smtp|mongodb|mongoerror|traceback|stack trace)/i;

function publicErrorMessage(message) {
  const text = String(message || "").trim();
  if (!text) return "Terjadi kesalahan, coba lagi.";
  if (INTERNAL_ERROR_PATTERN.test(text)) {
    return "Proses belum berhasil. Coba ulang sebentar lagi atau hubungi admin.";
  }
  return text;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("buzzr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;
    const method = String(config?.method || "get").toLowerCase();
    const status = Number(error?.response?.status || 0);
    const transient = !error?.response || [502, 503, 504].includes(status);
    if (config && ["get", "head"].includes(method) && transient && !config.signal && !config.__bkRetried) {
      config.__bkRetried = true;
      await new Promise((resolve) => window.setTimeout(resolve, 500 + Math.floor(Math.random() * 500)));
      return api.request(config);
    }
    return Promise.reject(error);
  },
);

export function formatErr(detail) {
  if (detail == null) return "Terjadi kesalahan, coba lagi.";
  if (typeof detail === "string") return publicErrorMessage(detail);
  if (Array.isArray(detail)) return publicErrorMessage(detail.map((e) => e?.msg || JSON.stringify(e)).join(" "));
  if (detail?.msg) return publicErrorMessage(detail.msg);
  if (detail?.message) return publicErrorMessage(detail.message);
  return publicErrorMessage(String(detail));
}

export const formatRupiah = (n) =>
  "Rp " + Math.round(Number(n || 0)).toLocaleString("id-ID");

export default api;
